<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-select
          v-model="tableQuery.coachIdList" style="width: 220px;"
          filterable placeholder="请输入姓名"
          remote reserve-keyword :remote-method="selectCoach" clearable multiple collapse-tags @change="selectPage">
        <el-option v-for="(coach,index) in coachList" :key="index" :label="coach.name" :value="coach.id">
          {{coach.id}} - {{coach.name}}
        </el-option>
      </el-select>
    </div>
    <el-table border class="table" :data="tableData"  height="600px" v-loading="tableQuery.loading" empty-text="空空如也～ ">
      <el-table-column prop="coachId" label="教练Id">
      </el-table-column>
      <el-table-column prop="coachName" label="姓名">
      </el-table-column>
      <el-table-column prop="deptName" label="姓名">
      </el-table-column>
      <el-table-column label="获取积分">
        <template #default="scope">
          <el-tag type="danger">共计：<span style="font-weight: bold;font-size: 14px;margin-right: 1px">{{scope.row.score}}</span>积分</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" align="center">
        <template #default="scope">
          <el-button type="danger" size="mini" @click="$refs.exchange.openDialog(scope.row)">兑换</el-button>
          <el-button type="danger" size="mini" @click="$refs.gainDetail.openDialog(scope.row.coachId)">明细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right;margin: 20px 10px"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="tableQuery.pageSize"
        @current-change="changePage"
        layout="total, prev, pager, next, jumper"
        :total="tableQuery.total">
    </el-pagination>
    <gain-detail ref="gainDetail"/>
    <exchange-product ref="exchange"/>
  </div>
</template>

<script>
import {selectTotalPointsPage} from '/src/api/contacts/hr/pointCard.js'
import GainDetail from "./gainDetail/GainDetail";
import ExchangeProduct from "./exchangeProduct/ExchangeProduct";
import {selectCoach} from "../../../../../../api/contacts/user";
export default {
  name: "TotalPoints",
  components:{
    GainDetail,ExchangeProduct
  },
  data() {
    return {
      coachList:[],
      coachLoading:false,
      tableData:[],
      tableQuery:{
        coachIdList:null,
        pageIndex:0,
        pageSize:11,
        loading:false
      }
    }
  },
  methods:{
    changePage(index){
      this.tableQuery.pageIndex = index;
      this.selectPage();
    },
    selectPage(){
      this.tableQuery.loading = true;
      selectTotalPointsPage(this.tableQuery).then(val=>{
        this.tableQuery.loading = false;
        if (val.status == 200){
          this.tableData = val.data.list;
          this.tableQuery.total = val.data.total;
        }
      })
    },
    selectCoach(val){
      this.coachLoading = true;
      selectCoach({coachName:val ? val:''}).then(val=>{
        this.coachLoading = false;
        this.coachList = val.data;
      })
    },
  },
  created() {
    this.selectPage();
    this.selectCoach();
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}
/**路由缩放动画会导致 el-select 高度回不去 这里写死高度**/
::v-deep .el-input__inner {
  height: 40px !important;
}
</style>